export class CannotReadNextValueError extends Error {
    delimiter;
    byteScanned;
    constructor(delimiter, byteScanned) {
        super(`Cannot find end of the row ${JSON.stringify(delimiter)}, or quoted value is too long. Scanned ${(byteScanned / 1024).toFixed(2)}KB, but then stopped.`);
        this.delimiter = delimiter;
        this.byteScanned = byteScanned;
    }
}
//# sourceMappingURL=CannotReadNextValueError.js.map